import styles from './BtnLoader.module.css';

const BtnLoader = ({ style }) => {
   return (
      <span className={styles.loader} style={style}></span>
   );
};

export default BtnLoader;